import api from '../lib/api'

export const getCreditStatus = (tenantId) =>
  api.get(`/billing/${tenantId}/status`).then(r => r.data)

export const manualTopup = (tenantId, pkg) =>
  api.post(`/billing/${tenantId}/topup/checkout`, {
    package: pkg,
    provider: 'onepay',
    payment_mode: 'redirect',
  }).then(r => r.data)

export const getPublicOnepayPaymentStatus = (ref) =>
  api.get('/public/payments/onepay/status', { params: { ref } }).then(r => r.data)

export const getSubscriptionPlans = () =>
  api.get('/subscription-plans').then(r => r.data?.plans ?? [])

export const getBillingTopupPackages = () =>
  api.get('/billing/packages/topup').then(r => r.data)

export const initiateSubscription = (tenantId, tier, durationMonths) =>
  api.post(`/billing/${tenantId}/subscription/checkout`, {
    plan_code: tier,
    duration_months: durationMonths,
    provider: 'onepay',
    payment_mode: 'redirect',
  }).then(r => r.data)

export const initiateTopup = (tenantId, pkg) =>
  api.post(`/billing/${tenantId}/topup/checkout`, {
    package: pkg,
    provider: 'onepay',
    payment_mode: 'redirect',
  }).then(r => r.data)
